import React, { Component } from 'react';
import { connect } from 'react-redux';
import { fetchResourceItem, } from "../redux/actions";
import {
    userSelector, resourceSelector, dkpSelector, chapterSelector, resourceContributionSelector,
} from "../redux/selectors";
import { toArray } from '../common/util';
import { ResponsiveContainer, LineChart, Line, XAxis, YAxis, Tooltip, Label, LabelList } from 'recharts';
import DKPResourceContributions from './DKPResourceContributions';
import moment from 'moment';
import {scaleTime} from "d3-scale"
import {timeDay} from "d3-time";

class DKPResourceDetail extends Component {

    componentDidMount() {
        document.title = "Addiction | DKP | " + this.props.match.params.id.toUpperCase() + " | History"
        this.props.getResourceItem(this.props.match.params.id)
    }
    data = []
    
    getTicks = (data) => {
        if (!data || !data.length ) {return [];}        
        const domain = [new Date(data[0].time), new Date(data[data.length - 1].time)];
        const scale = scaleTime().domain(domain).range([0, 1]);
        const ticks = scale.ticks(timeDay, 1);
        
        return ticks.map(entry => +entry);
    };
    
    getTicksData = (data, ticks) => {
        if (!data || !data.length ) {return [];}        
        const dataMap = new Map(data.map((i) => [i.time, i]));
        ticks.forEach(function (item, index, array) {
            if(!dataMap.has(item)) {
                data.push({time: item});
            }
        });
        return data;
    }
    
    dateFormat = (time) => {
        return moment(time).format('MMM D YYYY');
    };


    render() {
        if (toArray(this.props.resources.data).filter((resource) => resource.slug === this.props.match.params.id).length > 0) {
            this.data = toArray(this.props.resourceContributions.data)
                .filter((contrib) => this.props.resources.data[contrib.resource.id].slug === this.props.match.params.id)
                .map((contrib) => { return {
                    "Contributor": this.props.users[contrib.userDetail].displayName,
                    "Amount": Math.floor(contrib.amount),
                    "time": new Date(contrib.created).getTime(),
            }})
            console.log(toArray(this.props.resources.data).filter((resource) => resource.slug === this.props.match.params.id))
            const ticksArr = this.getTicks(this.data);
            const completeData = this.getTicksData(this.data, ticksArr);
            return (
                <div>
                    {toArray(this.props.resources.data)
                        .filter((resource) => resource.slug === this.props.match.params.id)
                        .map((resource) => (
                            <div>
                                <h1>{resource.title}</h1>
                                { toArray(this.props.resourceContributions.data)
                                    .filter((contrib) => this.props.resources.data[contrib.resource.id].slug === this.props.match.params.id).length > 0 ? (
                                <div className="panel-adt">
                                    <ResponsiveContainer height={300} width="100%">
                                    <LineChart                                 
                                        data={completeData}
                                        >
                                        <XAxis 
                                            dataKey="time" 
                                            type="number"
                                            ticks={ticksArr} 
                                            tickCount={ticksArr.length}
                                            tickFormatter={this.dateFormat}
                                            domain={[
                                                this.data[0].time,
                                                this.data[this.data.length -1].time
                                            ]}
                                        />
                                        <YAxis dataKey="Amount" type="number" domain={[
                                            'auto', 
                                            Math.max(...toArray(this.props.resourceContributions.data)
                                                .filter((contrib) => this.props.resources.data[contrib.resource.id].slug === this.props.match.params.id)
                                                .map((contrib) => {return contrib.amount}))
                                            ]} allowDataOverflow={false}>
                                            <Label 
                                                value="Transaction Amount"
                                                offset={0}
                                                position="insideLeft"
                                                angle={-90}
                                                style={{ fill: 'rgba(230, 230, 230, 0.87)' }}
                                            />
                                        </YAxis>
                                        <Tooltip contentStyle={{backgroundColor: "rgba(0, 0, 0, 0.65)", border: "0"}} labelFormatter={(date) => this.dateFormat(date)} /><Line stroke="none" fill="none" dataKey="Contributor" />
                                        <Line dataKey="Amount" stroke="#82ca9d" fill="#82ca9d" isAnimationActive={false} barSize="10px">
                                            <LabelList 
                                                dataKey="Contributor"
                                                position="top"
                                                style={{ fill: 'rgba(230, 230, 230, 0.87)' }}
                                            />
                                            <LabelList 
                                                dataKey="Amount"
                                                position="bottom"                                        
                                                style={{ fill: 'rgba(230, 230, 230, 0.87)' }}
                                            />
                                        </Line>
                                    </LineChart>
                                    </ResponsiveContainer>
                                </div>
                                ) : null }
                                <DKPResourceContributions section={this.props.dkp.data[resource.section]} resource={resource} />
                            </div>
                    ))}
                </div>
            )
        } else { return null }
    }
}

const mapStateToProps = (state) => ({
    users: userSelector(state),
    resources: resourceSelector(state),
    resourceContributions: resourceContributionSelector(state),
    dkp: dkpSelector(state),
    chapters: chapterSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    getResourceItem: (resource) => dispatch(fetchResourceItem(0,0,resource)),
});

export default connect(mapStateToProps, mapDispatchToProps)(DKPResourceDetail);


// WEBPACK FOOTER //
// ./src/DKP/DKPResourceDetail.js